import React, { useState, useRef } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import BusinessModelsSection from '../businessModels';
// import video from '../../../../../public/assests/video.mp4';
import one from '../AIML Icon/1.png'
import two from '../AIML Icon/2.png'
import three from '../AIML Icon/3.png'
import four from '../AIML Icon/4.png'
import five from '../AIML Icon/5.png'
import six from '../AIML Icon/6.png'
import seven from '../AIML Icon/6.png'
import Team from '../../../../assests/servicePage.png'
import Service from '../../../../assests/service.png'

import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaAngular,
  FaReact,
  FaVuejs,
  FaPhp,
  FaPython,
  FaNodeJs,
  FaJava,
  FaAws,
} from "react-icons/fa";

import {
  SiDvc,
  SiOpencv,
  SiHuggingface,
  SiFlask,
  SiFastapi,
  SiPostman,
  SiAmazonaws,
  SiMlflow,
  SiGooglecloud,
  SiNextdotjs,
  SiTailwindcss,
  SiBootstrap,
  SiOnnx,
  SiDjango,
  SiTensorflow,
  SiMaterialui,
  SiD3Dotjs,
  SiChartdotjs,
  SiPlotly,
  SiPython,
  SiTableau,
  SiPowerbi,
  SiMicrosoftazure,
  SiIbm,
  SiDocker,
  SiKubernetes,
  SiApacheairflow,
  SiSnowflake,
  SiTerraform,
  SiAnsible
} from "react-icons/si";
// RiTailwindCssLine
// const tabs = [
//   {
//     title: "1.AI Product Development ",
//     content: (
//       <>
//         <h3 className="lg:text-2xl text-[44px] font-semibold text-[#0A2C4C] font-recoleta mb-4">Share the requirement</h3>
//         <p className="lg:text-[19px] text-[34px] text-[#0A2C4C] mb-4 font-recoleta">
//           Understanding client requirements is key when it comes to staffing solutions. We ask our clients their demands, requirements, and goals to carefully analyze the suitable employees to recruit for their business.
//         </p>
//         <img
//           src="/images/Image%2026.png"
//           alt="UI/UX Design "
//           className="w-[260px] h-[194px] rounded-md"
//         />
//       </>
//     ),
//   },
//   {
//     title: "2. Machine learning solution",
//     content: (
//       <p className="lg:text-[19px] text-[34px] text-[#0A2C4C] font-recoleta">
//         We evaluate all candidates and shortlist only those who align with the client’s business, technical, and cultural requirements.
//       </p>
//     ),
//   },
//   {
//     title: "3. ChatBot solution",
//     content: (
//       <>
//         <h4 className="text-xl font-semibold text-[#0A2C4C] font-recoleta mb-2">Battery replacement</h4>
//         <p className="lg:text-[19px] text-[34px] text-[#0A2C4C]">
//           Your device may get switched off often despite charging it. Whether it is battery draining quickly or not holding charge, we offer replacement and warranty.
//         </p>
//         <img
//           src="https://static.zohocdn.com/sites/stock-images/images/zpstock-image-1263.webp"
//           alt="Battery replacement"
//           className="w-full max-w-md mt-4 rounded-md"
//         />
//       </>
//     ),
//   },
//   {
//     title: "4. AI consulting",
//     content: <p className="lg:text-[19px] text-[34px] text-[#0A2C4C]">We ensure smooth onboarding of selected candidates by handling documentation and welcome sessions.</p>,
//   }
// ];

// const tabs = [
//   {
//     name: "Front End",
//     items: [
//       { name: "Angular", icon: <FaAngular /> },
//       { name: "React", icon: <FaReact /> },
//       { name: "Vue.js", icon: <FaVuejs /> },
//       { name: "Next js", icon: <SiNextdotjs /> },
//       { name: "Tailwind Css", icon: <SiTailwindcss /> },
//       { name: "Bootstrap", icon: <SiBootstrap /> },
//       { name: "Onnx", icon: <SiOnnx /> },

//     ],
//   },
//   {
//     name: "Back End",
//     items: [
//       { name: "PHP", icon: <FaPhp /> },
//       { name: "Python", icon: <FaPython /> },
//       { name: "Node.js", icon: <FaNodeJs /> },
//       { name: ".NET", icon: <SiDotnet /> },
//       { name: "Java", icon: <FaJava /> },
//       { name: "Onnx", icon: <SiOnnx /> },
//       { name: "Django", icon: <SiDjango /> },
//       { name: "Mlflow", icon: <SiMlflow /> },

//     ],
//   },
//   {
//     name: "Databases",
//     items: [
//       { name: "MariaDB", icon: <SiMariadb /> },
//       { name: "SQLite", icon: <SiSqlite /> },
//       { name: "Mongodb", icon: <SiMongodb /> },
//       { name: "Postgres", icon: <SiPostgresql /> },
//       { name: "Mysql", icon: <SiMysql /> },
//     ],
//   },
//   {
//     name: "AI Services",
//     items: [
//       { name: "Machine Learning", icon: <img src='https://cdn-icons-png.flaticon.com/512/8345/8345929.png' className='lg:w-16 w-28' /> },
//       { name: "Deep Learning", icon: <img src='https://icon-library.com/images/learning-icon-png/learning-icon-png-15.jpg' className='lg:w-16 w-28' /> },
//       { name: "Natural Language Processing", icon: <img src='https://cdn-icons-png.flaticon.com/512/11743/11743780.png' className='lg:w-14 w-28' /> },
//       { name: "Robotic Process Automation", icon: <img src='https://cdn0.iconfinder.com/data/icons/robotics-24/32/robotic_process_automation_robot_rpa_robotic_program_robot_software-512.png' className='lg:w-16 w-28' /> },
//       { name: "Computer Vision And OCR", icon: <img src='https://static.thenounproject.com/png/286423-200.png' className='lg:w-12 w-28' /> },
//     ],
//   },
// ];

const tabs = [
  {
    name: "Front End",
    items: [
      { name: "React.js", icon: <FaReact /> },
      { name: "Angular", icon: <FaAngular /> },
      { name: "Vue.js", icon: <FaVuejs /> },
      { name: "Next.js", icon: <SiNextdotjs /> },
      { name: "TensorFlow js", icon: <SiTensorflow /> },
      { name: "ONNX.js", icon: <SiOnnx /> },
      { name: "Tailwind CSS", icon: <SiTailwindcss /> },
      // { name: "Material UI", icon: <SiMaterialui /> },
      { name: "Bootstrap", icon: <SiBootstrap /> },
      { name: "WebSockets / REST APIs", icon: <SiPostman /> }, // best fit
    ],
  },
  {
    name: "Back End",
    items: [
      { name: "Python", icon: <FaPython /> },
      { name: "FastAPI", icon: <SiFastapi /> },
      { name: "Flask", icon: <SiFlask /> },
      { name: "Django", icon: <SiDjango /> },
      { name: "R", icon: <img src="https://cdn.worldvectorlogo.com/logos/r-project.svg" className="lg:w-10 w-20" /> },
      { name: "Hugging Face", icon: <SiHuggingface /> },
      // { name: "spaCy", icon: <img src="https://spacy.io/static/img/logo.svg" className="lg:w-10 w-20" /> },
      { name: "OpenCV", icon: <SiOpencv /> },
      { name: "ONNX", icon: <SiOnnx /> },
      { name: "MLflow", icon: <SiMlflow /> },
      { name: "DVC", icon: <SiDvc /> },
    ],
  },
  {
    name: "Visualization",
    items: [
      { name: "D3.js", icon: <SiD3Dotjs /> },
      { name: "Chart.js", icon: <SiChartdotjs /> },
      { name: "Plotly.js", icon: <SiPlotly /> },
      // { name: "Recharts", icon: <img src="https://recharts.org/en-US/favicon.ico" className="lg:w-10 w-20" /> },
      // { name: "Highcharts", icon: <img src="https://www.highcharts.com/media/com_demo/highcharts-logo.svg" className="lg:w-12 w-20" /> },
      { name: "Matplotlib", icon: <SiPython /> },
      { name: "Seaborn", icon: <SiPython /> },
      // { name: "Dash", icon: <img src="https://plotly.com/all_static/images/dash/dash-logo-stripe.svg" className="lg:w-16 w-20" /> },
      { name: "Tableau", icon: <SiTableau /> },
      // { name: "Power BI", icon: <SiPowerbi /> },
    ],
  },
  {
    name: "Cloud & DevOps",
    items: [
      // { name: "AWS SageMaker", icon: <SiAmazonaws /> },
      { name: "Google Vertex AI", icon: <SiGooglecloud /> },
      // { name: "Azure ML", icon: <SiMicrosoftazure /> },
      // { name: "IBM Watson", icon: <SiIbm /> },
      { name: "Docker", icon: <SiDocker /> },
      { name: "Kubernetes", icon: <SiKubernetes /> },
      { name: "Airflow", icon: <SiApacheairflow /> },
      // { name: "Kubeflow", icon: <img src="https://upload.wikimedia.org/wikipedia/commons/1/18/Kubeflow-logo.svg" className="lg:w-12 w-20" /> },
      { name: "MLflow", icon: <SiMlflow /> },
      { name: "BigQuery", icon: <SiGooglecloud /> },
      // { name: "Redshift", icon: <SiAmazonaws /> },
      { name: "Snowflake", icon: <SiSnowflake /> },
      { name: "Terraform", icon: <SiTerraform /> },
      { name: "Ansible", icon: <SiAnsible /> },
    ],
  },
];

const services = [
  {
    icon: seven,
    title: "AI Consulting & Services",
    description: "TekIT offers end-to-end AI consulting and development services to help businesses harness the power of Artificial Intelligence. From strategy and model design to deployment and optimization, we deliver intelligent solutions tailored to your goals.",
    description1: "",
  },
  {
    icon: one,
    title: "Generative AI ",
    description: "Creates text, images, audio, video, and code from prompts.",
    description1:
      "Chatbots (ChatGPT), design (Midjourney), marketing content, code (GitHub Copilot), and more.",
  },
  {
    icon: two,
    title: "Natural Language Processing (NLP)",
    description: "Helps machines understand and generate human language.",
    description1: "Chatbots, voice assistants, sentiment analysis, summarization, translation.",
  },
  {
    icon: three,
    title: "Computer Vision & OCR",
    description: "Enables machines to interpret and analyze visual data.",
    description1: "Facial recognition, medical imaging, autonomous vehicles, surveillance.",
  },
  {
    icon: four,
    title: "AI-augmented RPA (Intelligent Automation)",
    description: "Combines RPA with AI for smarter automation.",
    description1: "Customer service, claims processing, back-office tasks.",
  },
  {
    icon: five,
    title: "Machine learning",
    description: "Learns patterns from large amounts of data to make predictions or decisions without being explicitly programmed.",
    description1: "Recommendation systems, fraud detection, speech recognition, image classification, and predictive analytics.",
  },
  {
    icon: six,
    title: "AI agents ",
    description: "Acts autonomously or semi-autonomously to perceive the environment, make decisions, and take actions to achieve specific goals.",
    description1: "Virtual assistants, chatbots, robotic process automation (RPA), game AI, and autonomous vehicles.",
  },

];

const tab = [
  {
    name: "AI Services",
    items: [
      { name: "Machine Learning", icon: <img src='https://cdn-icons-png.flaticon.com/512/8345/8345929.png' className='lg:w-16 w-28' /> },
      { name: "Deep Learning", icon: <img src='https://icon-library.com/images/learning-icon-png/learning-icon-png-15.jpg' className='lg:w-16 w-28' /> },
      { name: "Natural Language Processing", icon: <img src='https://cdn-icons-png.flaticon.com/512/11743/11743780.png' className='lg:w-14 w-28' /> },
      { name: "Robotic Process Automation", icon: <img src='https://cdn0.iconfinder.com/data/icons/robotics-24/32/robotic_process_automation_robot_rpa_robotic_program_robot_software-512.png' className='lg:w-16 w-28' /> },
      { name: "Computer Vision And OCR", icon: <img src='https://static.thenounproject.com/png/286423-200.png' className='lg:w-12 w-28' /> },
      // { name: "Vue.js", icon: <FaVuejs /> },
    ],
  },

];

const AIML_development = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeTab, setActiveTab] = useState("Front End");
  const currentTab = tabs.find((t) => t.name === activeTab);


  const [message, setMessage] = useState('');
  const videoRef = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    phone: '',
    email: '',
  });

  const playerRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.play();
    }
  }, []);

  const validate = () => {
    let newErrors = {};
    if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      try {
        // Add a "type" to formData before sending
        const payload = {
          ...formData,
          type: 'aiml',
        };
  
        const response = await fetch('https://www.tekitsolution.com/email_apis.php?action=service', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(payload).toString(),
        });
  
        const result = await response.json();
        alert('Form submitted successfully!');
  
        // Reset form
        setFormData({
            type:'aiml',
          phone: '',
          email: '',
        });
        setMessage('Message sent successfully!');
        setErrors({});
      } catch (error) {
        console.error('Error:', error);
        alert('Something went wrong. Please try again.');
      }
    } else {
      setErrors(validationErrors);
      setMessage('');
    }
  };

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelect = (index) => {
    setActiveIndex(index)
  }

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true, // whether animation should happen only once
    });
  }, []);

  return (
    <div className='bg-black'>
      <div className="curslide">
        {/* Background Image with Gradient Overlay */}

        <div className="relative bg-black w-full h-[500px] overflow-hidden">
  {/* Background video */}
  <video
    ref={videoRef}
    src="https://hrms-ezcompliance.s3.ap-south-1.amazonaws.com/uploads/1747037528906-newsd.mp4"
    className="w-full h-full object-cover"
    autoPlay
    muted
    loop
    playsInline
    preload="auto"
    poster="/fallback-thumbnail.jpg" // ✅ Add a lightweight preview image
  />

  
</div>


        {/* Hero Content */}
        <div className="absolute top-0 left-0 w-full h-full flex items-start justify-start">
          <div className="container mx-auto px-4 py-8">
            <div className="flex flex-col justify-start items-start h-full">
              <div className="w-full md:w-1/2 mt-52 lg:mt-[320px]">
                <h2 className="text-left text-black font-recoleta text-[58px] lg:text-4xl" data-aos="fade-up">
                  {/* AI-ML Development Services */}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <section className="px-4 py-10 bg-white">
          <div className="text-center mb-8">
            <h1 className="font-recoleta text-[54px] lg:text-[36px]" data-aos="fade-up">Intelligent Automation, Predictive Insights – Powered by TekIT</h1>
          </div>

          <div className="max-w-7xl mx-auto mb-10 space-y-6">
            {/* First item (full width) */}
            {services.length > 0 && (
              <div className="grid grid-cols-1">
                <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-md hover:shadow-lg transition duration-300">
                  <div className="flex justify-center mb-4">
                    <img
                      src={services[0].icon}
                      alt={`${services[0].title} Icon`}
                      className=" object-contain w-[2000px] lg:w-[600px] -mt-44  lg:mt-[-180px]"
                    />
                  </div>
                  <h3 className="lg:text-xl text-[53px] font-semibold text-[#0A2C4C] text-center mb-3 -mt-40 lg:mt-[-150px]">{services[0].title}</h3>
                  <p className="text-gray-700 text-[43px] lg:text-[18px]"><b>What it does:</b><span className='ml-3'>{services[0].description}</span></p>
                  {services[0].description1 && (
                    <p className="text-gray-700 text-[18px]">
                      <b>Used in:</b><span className='ml-3'>{services[0].description1}</span>
                    </p>
                  )}
                </div>
              </div>
            )}

            {/* Remaining items (3 per row) */}
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-6">
              {services.slice(1).map((service, idx) => (
                <div
                  key={idx}
                  className="bg-white border border-gray-200 rounded-lg p-6 shadow-md hover:shadow-lg transition duration-300"
                >
                  <div className="flex justify-center mb-4">
                    <img
                      src={service.icon}
                      alt={`${service.title} Icon`}
                      className="object-contain w-[2000px] lg:w-[600px] -mt-72 lg:mt-[-125px]"
                    />
                  </div>
                  <h3 className="lg:text-xl text-[53px] -mt-80  font-semibold text-[#0A2C4C] text-center mb-3 lg:mt-[-130px]">{service.title}</h3>
                  <p className="text-gray-700 text-[43px] lg:text-[18px]"><b>What it does:</b><span className='ml-3'>{service.description}</span></p>
                  {service.description1 && (
                    <p className="text-gray-700 text-[33px] pb-4 lg:pb-0 lg:text-[18px] mt-2">
                      <b>Used in:</b><span className='ml-3'>{service.description1}</span>
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>


          {/* <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 max-w-7xl mx-auto relative z-0">
            <div className="space-y-2 col-span-1 z-1 relative">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  className={`w-full text-left px-4 py-3 rounded-md font-recoleta transition text-[44px] lg:text-lg ${activeIndex === index
                    ? "text-[#F86F4B] border-r-4 border-[#F86F4B] bg-[#fef2f2]"
                    : "text-[#0A2C4C] hover:text-[#F86F4B] hover:bg-gray-100"
                    }`}
                  onClick={() => handleSelect(index)}
                >
                  {tab.title}
                </button>
              ))}
            </div>

            <div className="col-span-1 lg:colconst handleSubmit = async (e) => {
    e.preventDefault();
  
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      try {
        // Add a "type" to formData before sending
        const payload = {
          ...formData,
          type: 'MobileDevelopment',
        };
  
        const response = await fetch('https://www.tekitsolution.com/email_apis.php?action=contact_us', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(payload).toString(),
        });
  
        const result = await response.json();
        alert('Form submitted successfully!');
  
        // Reset form
        setFormData({
            type:'MobileDevelopment',
          phone: '',
          email: '',
        });
        setMessage('Message sent successfully!');
        setErrors({});
      } catch (error) {
        console.error('Error:', error);
        alert('Something went wrong. Please try again.');
      }
    } else {
      setErrors(validationErrors);
      setMessage('');
    }
  };-span-3 bg-gray-50 p-6 rounded-lg shadow-md h-fit relative z-0 font-recoleta">
              {tabs[activeIndex].content}
            </div>
          </div> */}
        </section>
        <section className="relative py-10 text-white font-recoleta">
          {/* Background Image */}
          <img
            src={Team}
            alt="img"
            className="absolute inset-0 w-full h-full object-cover z-0"
          />

          {/* Optional dark overlay */}
          <div className="absolute inset-0 z-0"></div>

          {/* Content */}
          <div className="relative z-1 container mx-auto px-4">
            {/* Title */}
            <div className="text-center mb-8">
              <h2 data-aos="fade-up" className="2xl:text-[40px] lg:text-[32px] text-[54px] font-bold mb-2">
                <strong>Technologies</strong> We Work With
              </h2>
              <p data-aos="fade-up" className="2xl:text-[26px]  lg:text-[20px] text-[34px]">
                Check out what programming languages, database systems, and platforms we use to complete projects for{" "}
                  our clients
              </p>
            </div>

            {/* Tabs */}
            <div className="flex flex-wrap justify-center lg:gap-4 gap-8 mb-8">
              {tabs.map((tab) => (
                <button
                  key={tab.name}
                  onClick={() => setActiveTab(tab.name)}
                  className={`px-4 2xl:text-[24px]  lg:text-[20px]  text-[23px] py-2 rounded-3xl w-[230px] font-medium transition ${activeTab === tab.name
                    ? "bg-white text-black shadow"
                    : "bg-transparent text-white border border-white hover:text-white hover:border-white"
                    }`}
                >
                  {tab.name}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div className="flex gap-4 justify-center mb-6">

            </div>

            {/* Tech Icons */}
            <div className="grid lg:grid-cols-3 grid-cols-2 lg:px-32 justify-self-center flex-wrap justify-center gap-6">
              {currentTab?.items.map((tech) => (
                <div
                  key={tech.name} data-aos="fade-up"
                  className="bg-white text-black  p-10 lg:mt-0 mt-10 rounded-lg shadow flex flex-col items-center justify-center"
                >
                  <div className="lg:text-4xl text-[80px] mb-2">{tech.icon}</div>
                  <p className="lg:text-[18px] text-[60px] font-medium text-center">{tech.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <BusinessModelsSection />
        <div className="p-4 lg:p-10 lg:px-48 px-10 bg-white font-recoleta">
          <h2 data-aos="fade-up" className="text-[54px] 2xl:text-[40px] lg:text-[32px] text-center font-bold text-[#002856] mb-8 font-recoleta">
            Schedule Call
          </h2>

          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div>
                <input
                  data-aos="fade-up"
                  name="email"
                  placeholder="Email *"
                  className="w-full border border-gray-300 p-4 rounded text-[32px] lg:text-[20px]"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <p className="text-red-500 text-[24px] lg:text-sm">{errors.email}</p>}
              </div>

              <div>
                <input
                  data-aos="fade-up"
                  name="phone"
                  placeholder="Phone"
                  className="w-full border border-gray-300 p-4 rounded text-[32px] lg:text-[20px]"
                  value={formData.phone}
                  onChange={handleChange}
                />
                {errors.phone && <p className="text-red-500 lg:text-sm text-[24px]">{errors.phone}</p>}

              </div>
            </div>

            <div className="justify-center gap-4 mt-6 grid grid-cols-1 px-10  lg:hidden justify-self-center">
              <button
                type="submit"
                className="bg-[#00447b] w-full text-white py-2 px-6 rounded-full hover:bg-[#00325c] duration-300 text-[28px] lg:text-[20px]"
              >
                Submit
              </button>
            </div>
            <div className="justify-center gap-4 mt-6 lg:flex px-10 lg:block hidden ">
              <button
                type="submit"
                data-aos="fade-up"
                className="bg-[#00447b] lg:w-52 w-full text-white py-2 px-6 rounded-full hover:bg-[#00325c] duration-300"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AIML_development